import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Card, CardHeader} from "reactstrap";
import Answer from "./Answer";
import Sortable from "react-sortablejs";

class BasketTarget extends PureComponent {
  render() {
    const { basket, answers, question, details } = this.props;

    let isFull = false;
    if (basket.answersMax > 0) {
      isFull = basket.answersMax === answers.length;
    } else if (question.answersMax > 0) {
      isFull = question.answersMax === answers.length;
    }

    return <div className="basket mb-2">
        <div className="basket-header text-center" dangerouslySetInnerHTML={{__html: basket.content}} />
        <div className="basket-body">
          <Sortable
              class={"answers-container"}
              options={{
              //   scroll: true,
              //   bubbleScroll: true,
              // forceFallback: false,
                group: {
                  name: 'basket-basket-' + question.id,
                  put: ['basket-answers-' + question.id, 'basket-basket-' + question.id],
                },
                animation: 100,
              }}
              onChange={(order, sortable, evt) => {
                if (!isFull) {
                  this.props.handleDrop(basket.id, parseInt(evt.item.dataset.a))
                }
              }}
          >
          <React.Fragment>
            {details.map((detail, key) => {
              const answer = question.answers.find(answer => parseInt(answer.id) === parseInt(detail.answer));
              return <Answer
                key={key}
                isActive={true}
                answer={answer}
                basket={basket}
                question={question}
                handleDrop={this.props.handleDrop}
                onAnswerOpenChange={content => this.props.onAnswerOpenChange(answer.id, content)}
                detail={detail}
              />
            })}
          </React.Fragment>
          </Sortable>
          {isFull === false && <div className={"empty-answer text-center"}>
            <i className={"fas fa-circle-plus"}/>
          </div>}
        </div>
      </div>
  }
}

BasketTarget.propTypes = {
  basket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
  question: PropTypes.shape({
    answersImage: PropTypes.bool.isRequired,
    answers: PropTypes.array.isRequired,
  }).isRequired,
  answers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }),).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    basket: PropTypes.number.isRequired,
  }).isRequired,),
  handleDrop: PropTypes.func.isRequired,
};

export default BasketTarget;